module.exports = __webpack_public_path__ + "static/media/35.7809322b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/35.jpg
// module id = 725
// module chunks = 0